/** BCP 47 locale tags supported at launch (WP-046). */
export const SUPPORTED_LOCALES = ["en-US", "fr", "de", "it", "es", "ru"] as const;

export type LocaleTag = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: LocaleTag = "en-US";

export const FALLBACK_LOCALE: LocaleTag = "en-US";

export type MessageNamespace = "common";

export const MESSAGE_NAMESPACES: MessageNamespace[] = ["common"];

export type LocaleDisplayName = {
  tag: LocaleTag;
  /** English label for settings pickers */
  label: string;
  /** Endonym shown as secondary text */
  nativeLabel: string;
};

export const LOCALE_DISPLAY_NAMES: LocaleDisplayName[] = [
  { tag: "en-US", label: "English (US)", nativeLabel: "English (US)" },
  { tag: "fr", label: "French", nativeLabel: "Français" },
  { tag: "de", label: "German", nativeLabel: "Deutsch" },
  { tag: "it", label: "Italian", nativeLabel: "Italiano" },
  { tag: "es", label: "Spanish", nativeLabel: "Español" },
  { tag: "ru", label: "Russian", nativeLabel: "Русский" },
];

/** Clerk `@clerk/localizations` pack ids for auth UI. */
export const CLERK_LOCALIZATION_BY_LOCALE: Record<LocaleTag, string> = {
  "en-US": "enUS",
  fr: "frFR",
  de: "deDE",
  it: "itIT",
  es: "esES",
  ru: "ruRU",
};

export function clerkLocalizationId(locale: LocaleTag): string {
  return CLERK_LOCALIZATION_BY_LOCALE[locale];
}

export function localeNativeLabel(tag: LocaleTag): string {
  return LOCALE_DISPLAY_NAMES.find((entry) => entry.tag === tag)?.nativeLabel ?? tag;
}

export function isSupportedLocale(value: string): value is LocaleTag {
  return (SUPPORTED_LOCALES as readonly string[]).includes(value);
}
